import { useApolloClient } from '@apollo/client'
import { GatsbyLinkProps, Link, navigate } from 'gatsby'
import { forwardRef } from 'react'

import { Breadcrumb, Search, TagCloud } from '@karakuri-ai/faq-component'

import { SettingYamlCategory } from '../graphql'
import { EventTrigger } from '../utils/event-trigger'

import { GQL_SEARCH_FAQ } from './graphql'
import { Breadcrumb as BreadcrumbType, Hierarchy, TagCloud as TagCloudType } from './interface'

interface Props {
  botId: string
  breadcrumb: BreadcrumbType
  tagCloud: TagCloudType
  relatedCategories?: SettingYamlCategory[]
  hierarchies: Hierarchy[]
  searchWaitMs: number
  topTitle: string
  searchType: string
}
export function NaviWidget({
  botId,
  hierarchies,
  breadcrumb,
  tagCloud,
  relatedCategories,
  searchWaitMs,
  topTitle,
  searchType,
}: Props) {
  const client = useApolloClient()
  const r = relatedCategories || []
  const tags = tagCloud
    ? [
        { link: '/', title: topTitle },
        ...r.map(c => {
          const title = c.title || ''
          return { link: `/category/${c.id}`, title }
        }),
      ]
    : []
  const handleSearched = (inputValue: string, result: any[]) => {
    EventTrigger.search(inputValue, result)
  }
  const LinkComponent = forwardRef<HTMLAnchorElement, GatsbyLinkProps<Record<string, unknown>>>(
    function LinkComponent(props, ref) {
      const found = hierarchies.findIndex(h => h.link === props.to)
      const h = hierarchies.slice(0, found)
      const newProps: Omit<GatsbyLinkProps<Record<string, unknown>>, 'to'> = {}
      if (h.length > 0) {
        newProps.state = { hierarchies: h }
      }
      return <Link ref={ref as any} {...{ ...props, ...newProps }} />
    }
  )
  return (
    <div className="faq-navigation">
      {tagCloud ? (
        <TagCloud tags={tags} LinkComponent={LinkComponent} />
      ) : (
        <Breadcrumb {...breadcrumb} topTitle={topTitle} LinkComponent={LinkComponent} />
      )}

      <Search
        onClick={navigate}
        onSearched={handleSearched}
        searchWaitMs={searchWaitMs}
        search={inputValue =>
          client.query({
            query: GQL_SEARCH_FAQ,
            variables: { botId, inputValue: inputValue || '', searchType },
          })
        }
      />
    </div>
  )
}
